import React, { useEffect, useState } from 'react';
import { DatePicker, Form, Image, Input } from 'antd';
import Payment from '../../../classes/payment';
import { Utils } from '../../../tools/utils';
import visaLogo from '../../../../assets/img/payment-logos/1.png';
import masterCardLogo from '../../../../assets/img/payment-logos/2.png';
import amexLogo from '../../../../assets/img/payment-logos/3.png';
import { StringFormats } from '../../../config/config';
import { useTranslation } from 'react-i18next';
import { useStore } from 'store';
import SicuriProtettiServices from 'js/data/sicuri-protetti-services';

const { monthYearShortDateFormat } = StringFormats;
const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 8 },
};

interface IProps {
    data: Payment;
    formRef: any;
}

const CreditCardForm = (props: IProps) => {
    const { t } = useTranslation();
    const setLoading = useStore((state) => state.setLoading);
    const [circuits, setCircuits] = useState<simpleStruct[]>([]);
    const utils = new Utils(t);
    useEffect(() => {
        const getCreditCardTypes = async () => {
            setLoading(true);
            const circuits = await SicuriProtettiServices.getCreditCardTypes();
            setCircuits(circuits);
            if (props.data.circuitId !== undefined)
                document
                    .getElementById('circuit-' + props.data.circuitId)!
                    .querySelector('img')!
                    .classList.remove('image-disabled');
            setLoading(false);
        };

        getCreditCardTypes();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            {circuits.map((circuit) => {
                let logo;
                switch (circuit.value.toString()) {
                    case '1':
                        logo = visaLogo;
                        break;
                    case '2':
                        logo = masterCardLogo;
                        break;
                    case '3':
                        logo = amexLogo;
                        break;
                }
                return (
                    <Image
                        style={{ width: 'auto', height: 35, margin: 10 }}
                        className="image-disabled"
                        key={circuit.value}
                        src={logo}
                        id={'circuit-' + circuit.value}
                        preview={false}
                    ></Image>
                );
            })}
            <Form.Item
                {...formItemLayout}
                name="cardNumber"
                label={t('customerClass.payments.cardNumber')}
                initialValue={props.data.cardNumber}
                rules={[
                    {
                        required: true,
                        validator: utils.ValidateCard,
                    },
                ]}
            >
                <Input onChange={(e) => utils.GetCreditCardType(e, props.formRef)} placeholder={t('customerClass.payments.cardNumber')} />
            </Form.Item>
            <Form.Item
                {...formItemLayout}
                name="cardExpirationDate"
                label={t('customerClass.payments.cardExpirationDate')}
                initialValue={props.data.cardExpirationDate}
                rules={[
                    {
                        required: true,
                        message: t('errorMessages.cardExpirationDateReq'),
                    },
                ]}
            >
                <DatePicker format={monthYearShortDateFormat} picker="month" disabledDate={utils.DisableDateOfPresentAndPassedMonth} />
            </Form.Item>
            <Form.Item
                {...formItemLayout}
                name="accountHolder"
                label={t('customerClass.payments.accountHolder')}
                initialValue={props.data.accountHolder}
                rules={[
                    {
                        required: true,
                        message: t('errorMessages.accountHolderReq'),
                    },
                ]}
            >
                <Input placeholder={t('customerClass.payments.accountHolder')} />
            </Form.Item>
            <Form.Item name="circuitId" initialValue={props.data.circuitId}>
                <Input hidden data-circuit={props.data.circuit} />
            </Form.Item>
        </>
    );
};

export default CreditCardForm;
